export const PartnerStoreKey = 'PartnerStore';

export type PartnerStore = {
    partner: string | null,
    partnerReferenceId: string | null
}
export const getPartnerStore = (): PartnerStore | null => {
    const partnerStore = localStorage.getItem(PartnerStoreKey);
    if (partnerStore) {
        return JSON.parse(partnerStore);
    }
    return null;
};